module.exports = __webpack_public_path__ + "static/img/ic_circle_center.da6c966.png";